/**
 * Unités avec libellés en entier (pour factures, devis, produits).
 * On stocke et affiche les libellés complets.
 */

export const UNITES = [
  "Unité(s)",
  "Pièce(s)",
  "Kilogramme(s)",
  "Mètre(s)",
  "Heure(s)",
  "Jour(s)",
] as const;

export type Unite = (typeof UNITES)[number];

/** Anciennes abréviations → libellé complet (compatibilité données existantes) */
const ABREV_TO_LIBELLE: Record<string, string> = {
  unité: "Unité(s)",
  unite: "Unité(s)",
  pcs: "Pièce(s)",
  kg: "Kilogramme(s)",
  m: "Mètre(s)",
  h: "Heure(s)",
  j: "Jour(s)",
};

/** Retourne le libellé complet pour l’affichage (gère les anciennes abréviations). */
export function getUniteLabel(unite: string | null | undefined): string {
  if (!unite || !unite.trim()) return "Unité(s)";
  const u = unite.trim();
  return ABREV_TO_LIBELLE[u] ?? u;
}

/** Normalise une valeur (abréviation ou libellé) vers le libellé complet pour les listes déroulantes. */
export function normalizeUnite(unite: string | null | undefined): string {
  const label = getUniteLabel(unite);
  return UNITES.includes(label as Unite) ? label : UNITES[0];
}
